import { TemplatePageShopAll } from './TemplatePageShopAll';

export class TemplatePageShopAll20 extends TemplatePageShopAll {}
